import { modalStore } from 'state/store';
import { ModalName, ModalPropsType } from 'features/Modals/ModalProvider';

export type ParticipantsLimitModalState = {
    isRetryLoading: boolean;
    onRetry: () => void;
    onClose: () => void;
};

export const selectOpenedModalName = () => {
    return modalStore.getModalName;
};

export const selectIsModalOpened = (modalName?: ModalName): boolean => {
    const opened = modalStore.getModalName;
    return modalName === undefined ? !!opened : opened === modalName;
};

export const selectModalDataData = (): ModalPropsType => {
    return modalStore.getPayload;
};

export const selectParticipantsLimitModalData = (): ParticipantsLimitModalState | null => {
    if (modalStore.getModalName !== ModalName.PARTICIPANTS_LIMIT) return null;
    return (modalStore.getPayload as ParticipantsLimitModalState) ?? null;
};
